import React, { Fragment, useState, useEffect, useMemo } from "react";
import Breadcrumb from "../../layout/breadcrumb";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { getAllAdminWalletHistory, getWalletBalance } from "../../api";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import formatedDate from "../../utilities/formatedDate";
import convertToRupees from "../../utilities/convertToRupees";
import GetButtons from "../common/getButtons";
import GetExport from "../common/getExport";
import { MASTER_ADMIN_HASH, MASTER_ADMIN_WALLET_ID, paymentTypeOptionsForFilter } from "../../constant";

const EAWalletHistory = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [adminWalletBalance, setAdminWalletBalance] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([{ "id": "brand_id", "desc": true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // const ADMIN_HASH = "52068336023303627958320186912868";
  // const ADMIN_WALLET_ID = 53;

  const [adminWalletPayload, setAdminWalletPayload] = useState({
    hash: MASTER_ADMIN_HASH,
    user_wallet_id: MASTER_ADMIN_WALLET_ID,
  });

  useEffect(() => {
    getData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters, sorting]);


  const getData = async (page, rowsPerPage, searchText, columnFilters, sorting) => {
    setIsLoading(true);
  
    try {
      const historyResponse = await getAllAdminWalletHistory(adminWalletPayload, page, rowsPerPage, searchText || "", columnFilters, sorting);
      const historyResult = historyResponse.data.result?.result;
      setData(historyResult);
      setCount(historyResponse.data.result?.totalCount);


  
      const balanceResponse = await getWalletBalance(adminWalletPayload);
      const balanceResult = balanceResponse.data.result;
      setAdminWalletBalance(balanceResult.balance);
    } catch (error) {
      // toast.error(error.response.data.error);
    } finally {
      setIsLoading(false);
    }
  };
  



  const refresh = () => {
    getData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  };

  const columns = useMemo(
    () => [
      
      {
        accessorKey: "createdAt",
        header: "Time",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        size: 80,
        Cell: ({ row }) => (
          <div>
            {row.original?.adminHistory?.createdAt
              ? formatedDate(row.original?.adminHistory?.createdAt)
              : "N/A"}
          </div>
        ),
      },

      {
        accessorKey: "utrNo",
        header: "Certificate/TXN",
        filter: false,
        // enableClickToCopy: true,
        Cell: ({ row }) => (
          <div>{row.original.PolicyTransaction?.certificate}</div>
        ),
        // Cell: ({ row }) => (
        //   <>
        //     {row.original?.PolicyTransaction?.certificate
        //       ? row.original.PolicyTransaction.certificate
        //       : ""}
        //   </>
        // ),
      },
      {
        accessorKey: "CTYPE",
        header: "Type",
        filter: false,
        filterVariant: 'select',
        enableClickToCopy: false,
        filterSelectOptions: paymentTypeOptionsForFilter,
        Cell: ({ row }) => {
          const modeMappings = {
            online: "Payment Gateway",
            offline: "EA Wallet",
            va_navision_dealer: "ECollection",
            va_navision_admin: "ECollection map",
            policy_refund: "Policy refund",
            wallet_refund: "Wallet refund",
            self_online: "Payment Gateway",
          };

          let mode = "N/A";

          if (row.original?.adminHistory?.CTYPE) {
            const CTYPE = row.original.adminHistory.CTYPE.toLowerCase();
            mode = modeMappings[CTYPE] || "N/A";
          }

          return <div>{mode}</div>;

          // return <div>{mode + ' '+ row.original.walletHistoryData.CTYPE}</div>;
        },
      },
      {
        accessorKey: "updated_amount",
        header: "Used",
        filter: false,
        size: 80,
        enableClickToCopy: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <div className="font-danger">
            {row.original?.adminHistory?.TYPE === "SUB"
              ? row.original?.adminHistory?.updated_amount
                ? convertToRupees(
                    row.original?.adminHistory?.updated_amount
                  )
                : "N/A"
              : ""}
          </div>
        ),
      },
      {
        accessorKey: "updated_amount",
        header: "Added",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <div className="font-success">
            {row.original?.adminHistory.TYPE === "ADD"
              ? convertToRupees(row.original?.adminHistory.updated_amount)
              : "-"}
          </div>
        ),
      },
      // {
      //   accessorKey: "walletHistoryData",
      //   header: "Added",
      //   filter: false,
      //   enableClickToCopy: false,
      //   size: 80,
      //   Cell: ({ row }) => {
      //     return (
      //       <div className="font-success">
      //         {row.original?.walletHistoryData?.TYPE === "ADD"
      //           ? row.original?.walletHistoryData?.updated_amount
      //             ? convertToRupees(
      //                 row.original?.walletHistoryData?.updated_amount
      //               )
      //             : "N/A"
      //           : ""}
      //         {/* {shouldRenderDiv  &&   */}
      //         {row.original?.walletHistoryData?.TYPE === "ADD" &&
      //         row.original?.walletHistoryData?.updated_amount > 0 &&
      //         (row.original?.walletHistoryData?.CTYPE?.toLowerCase() ===
      //           "self_online" ||
      //           row.original?.walletHistoryData.CTYPE?.toLowerCase() ===
      //             "va_navision_dealer") &&
      //         getFromLocalStorage("ROLE")?.key === "DEALERSHIP_MANAGER" &&
      //         row.original?.walletHistoryData?.updated_amount < balance &&
      //         row.original?.WalletTransaction?.refund == null &&
      //         walletTransactionsDataFiltered?.some(
      //           (item) =>
      //             item.WalletTransaction?.txn_history_id ===
      //             row.original.WalletTransaction?.txn_history_id
      //         ) ? (
      //           // walletTransactionsDataFiltered?.length > 0 &&
      //           // walletTransactionsDataFiltered[1]?.WalletTransaction?.txn_history_id === row.original.WalletTransaction?.txn_history_id &&
      //           // row.original?.isRefundAllowed ?
      //           <>
      //             <div className="font-success">
      //               {/* Render your content here */}
      //               <div className="txt-info">
      //                 <span
      //                   onClick={(e) => showRequestRefundModal(e, row.original)}
      //                   style={{
      //                     cursor: "pointer",
      //                   }}
      //                 >
      //                   Raise Refund
      //                 </span>
      //               </div>
      //             </div>
      //           </>
      //         ) : null}
      //         {/* <>
      //   <div className="txt-info">
      //     <span
      //       onClick={(e) => showRequestRefundModal(e, row.original)}
      //       style={{
      //         cursor: "pointer",
      //       }}
      //     >
      //       Raise Refund
      //     </span>
      //   </div>
      // </>  */}
      //         {/* } */}
      //       </div>
      //     );
      //   },
      //   // }
      // },
      {
        accessorKey: "available_amount",
        header: "Balance",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <div>
            <div className="font-success">
              {row.original?.adminHistory?.available_amount
                ? row.original?.adminHistory?.available_amount
                  ? convertToRupees(
                      row.original?.adminHistory?.available_amount
                    )
                  : "N/A"
                : ""}
            </div>
          </div>
        ),
      },

      {
        accessorKey: "adminHistory.status",
        header: "Remark",
        filter: false,
        enableClickToCopy: false,
        enableColumnFilter: false,
      },
    ],
    []
  );

  
 
    const exportedData = data.map((item) => ({
      Time: formatedDate(item.createdAt),
      Transaction: item.user_wallet_history_id,
      Mode: item.CTYPE,
      Used: item.updated_amount,
      Added: item.updated_amount,
      Balance: item.available_amount,
    }));

    

  return (
    <Fragment>
      <Breadcrumb parent="Navision" title="EA Wallet" />
      <Container fluid={true}>
        <Row>
          <Col xl="9 xl-100" className="chart_data_left box-col-12">
            <Card>
              <CardBody className="p-0">
                <Row className="m-0 chart-main">
                <Col xl="4" md="4" sm="4" className="p-0 box-col-4">
                      <div className="media align-items-center p-3">
                        <div className="media-body">
                          <div className="right-chart-content">

                            <h5>
                              {isLoading ? (
                                'Loading....'
                              ) : (
                                convertToRupees(adminWalletBalance)
                              )}
                            </h5>

                            <span>{"Current Balance"} </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" md="4" sm="4" className="p-0 box-col-4">
                      <div className="media align-items-center p-3">
                        <div className="media-body">
                          <div className="right-chart-content">
                            <h5>
                              {isLoading ? (
                                'Loading....'
                              ) : (
                                count
                              )}
                            </h5>
                              <span>{"Transaction"}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <div>
        <MaterialReactTable
          columns={columns}
          data={data}
          initialState={{ showColumnFilters: false, density: "compact" }}
          enableGlobalFilter={false}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          defaultColumn={{
            maxSize: 400,
            minSize: 80,
            size: 150, //default size is usually 180
          }}
          // enableColumnResizing
          columnResizeMode="onChange" //default
          renderTopToolbarCustomActions={({ table }) => (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "0.3rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <GetButtons onClick={refresh} type="refresh" />
                {/* <GetButtons onClick={handleExportData} type="export" /> */}
                <GetExport columns={columns} exportedData={exportedData} name="EA_Wallet" />
          
              </Box>
            </>
          )}
          rowCount={count}
          // rowCount={2000}
          state={{
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            sorting,
          }}
        />
      </div>
    </Fragment>
  );
};

export default EAWalletHistory;
